import { List } from 'immutable';
import { actions } from './actions';
import * as lib from './lib';

export const initialState = new List();

/**
 * handles incoming action requests for the timeclock activity
 * @param  {Map} state: current state
 * @param  {String} type: the type of action to be executed on state
 * @param  {*} value: any association value
 * @return {Map} the new state
 */
export default function reducer(state = initialState, { type, value }) {
  switch (type) {
    case actions.ADD:
      return lib.add(state, value);
    case actions.REMOVE:
      return lib.remove(state, value);
    case actions.REMOVE_BY_TYPE:
      return lib.removeByType(state, value);
    case actions.CLEAR:
      return lib.clearMessages(state);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/messages/systemMessages/reducer.js